import React from 'react';

import { Link } from '../../Link';

export const NavigationMenu = () => (
  <>
    <p>NAVEGAÇÃO</p>
    <ul>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/ofertas" absolute>
          Ofertas
        </Link>
      </li>
      <li>
        <Link to="/sobre">O Pagar.me</Link>
      </li>
      <li>
        <Link to="https://conteudo.stone.com.br/">Blog</Link>
      </li>
      <li>
        <Link to="/negocios-que-atendemos">Negócios que atendemos</Link>
      </li>
      <li>
        <Link to="/produtos">Produtos</Link>
      </li>
    </ul>
  </>
);
